package com.fantasytenis.shared.domain.notifications.usecases

import com.fantasytenis.shared.core.utils.SharedData
import com.fantasytenis.shared.domain.notifications.NotificationsRepository

/**
 * Use case for marking all notifications as read.
 * Updates SharedData accordingly.
 */
class MarkAllNotificationsReadUseCase(
    private val repository: NotificationsRepository
) {
    /**
     * Mark all notifications as read.
     */
    suspend operator fun invoke(): Result<Boolean> = runCatching {
        val success = repository.markAllAsRead()

        if (success) {
            // Update all notifications in SharedData
            val current = SharedData.notifications.value
            SharedData.notifications.value = current.map { it.copy(read = true) }

            // Reset unread count
            SharedData.unreadNotificationCount.value = 0
        }

        success
    }
}
